import styled from '@emotion/styled';
import { FormLabel } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Title = styled(FormLabel)`
  font-weight: bold;
`;
